import styled from '@emotion/styled'
import Avatar from '../../components/Avatar'
import HeroImage from '../../components/HeroImage'
import ListRow from '../../components/ListRow'
import UserMeta from '../../components/UserMeta'

const Bio = styled.div`
  margin-bottom: 2rem;
`

const StyledAvatar = styled(Avatar)`
  float: left;
  margin-bottom: 1rem;
  margin-right: 1rem;
`

const StyledHeroImage = styled(HeroImage)`
  margin-bottom: 1rem;
`

const Username = styled.h2`
  float: left;
  line-height: 3rem;
  margin: 0;
  padding: 0;
`

const UserLists = ({ lists, user }) => {
  if (lists.length > 0) {
    return (
      <div className="mb4 mb5-ns mw7 w-100">
        {lists.map((list) => (
          <ListRow className="mb4" displayDate key={list.slug} {...list} />
        ))}
      </div>
    )
  } else {
    return (
      <h2 className="f3 fw6 lh-copy mb4 mb5-ns mv0 tracked-light w-100">
        {user.username} hasn&apos;t written any lists yet
      </h2>
    )
  }
}

const UserPage = ({ lists, user }) => (
  <>
    <UserMeta user={user} />

    {user.hero_image && <StyledHeroImage src={user.hero_image} />}

    <div>
      {user.avatar && <StyledAvatar src={user.avatar} alt={user.username} />}
      <Username>{user.username}</Username>
    </div>

    {user.bio && (
      <Bio
        dangerouslySetInnerHTML={{
          __html: user.bio,
        }}
      />
    )}

    <UserLists lists={lists} user={user} />
  </>
)

export async function getServerSideProps(context) {
  const { username } = context.params
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_HOSTNAME}/api/user/${username}`
  )
  const { lists, user } = await res.json()

  if (!user) return { notFound: true }

  return {
    props: {
      lists,
      user,
    },
  }
}

export default UserPage
